import type { Component, JSX } from 'solid-js';
import { Show } from 'solid-js';
import { onMountAnimate, enter } from '~/shared/lib/motion';

export interface EmptyStateProps {
  illustration?: JSX.Element;
  title: string;
  hint?: string;
  action?: JSX.Element;
}

export const EmptyState: Component<EmptyStateProps> = (props) => (
  <div
    ref={onMountAnimate(enter, { duration: 360 })}
    class="flex flex-col items-center text-center py-16 px-6"
  >
    <Show when={props.illustration}>
      <div class="mb-5 text-tertiary" aria-hidden="true">
        {props.illustration}
      </div>
    </Show>
    <p
      class="text-[20px] font-semibold leading-snug tracking-tight"
      style={{ 'font-family': 'var(--font-display)' }}
    >
      {props.title}
    </p>
    <Show when={props.hint}>
      <p class="mt-2 max-w-[420px] text-[14px] text-secondary">{props.hint}</p>
    </Show>
    <Show when={props.action}>
      <div class="mt-6">{props.action}</div>
    </Show>
  </div>
);
